import { TreeSelect } from 'antd';

import { styled } from '@mui/material';

export const TreeSelectStyled = styled(TreeSelect)`
  height: 40px;
  &:hover {
    .ant-select-selector {
      border-color: ${({ theme }) => theme.vars.palette.primary.main} !important;
    }
  }
  &.ant-select-focused {
    .ant-select-selector {
      border-color: ${({ theme }) => theme.vars.palette.primary.main};
    }
  }
`;
